:host {
  display: block;
}

img {
  max-width: 100%;
}
